module.exports = __webpack_public_path__ + "static/assets/f3a736bef507eda95c472eee99909a6a.gif";